import {
  FETCH,
  FETCH_ARTICLE_PAGE,
  RECEIVED_ARTICLE_PAGE,
  error,
  received,
  receivedArticlePage,
} from '../store/modules/tag'
import {
  map as fmap,
  join,
  prop,
} from 'ramda'
import { combineEpics, ofType } from 'redux-observable'
import {
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs'
import { logObservableError, logObservableErrorAndTriggerAction } from '../utilities/logs'
import { formatArticle } from '../utilities/miscellaneous'
import { calculateTotalPages } from '../utilities/paginations'
import { receivedPage } from '../store/modules/pagination'

// fetchCurrentTagEpic :: Epic -> Observable Action.RECEIVED
export const fetchCurrentTagEpic = (action$, state$, { fetchApi, logger }) =>
  action$.pipe(
    ofType(FETCH),
    withLatestFrom(state$),
    mergeMap(([ action, state ]) => fetchApi(`/v2/${state.router.locale}/tags/${state.router.activeRoute.params.tag}`)),
    map(prop('body')),
    map(received),
    logObservableErrorAndTriggerAction('tag :: fetchCurrentTagEpic', error, logger),
  )

// fetchArticlesFromCurrentTagEpic :: Epic -> Observable Action.RECEIVED_ARTICLES
export const fetchArticlesFromCurrentTagEpic = (action$, state$, { document, fetchApi, logger }) =>
  action$.pipe(
    ofType(FETCH_ARTICLE_PAGE),
    withLatestFrom(state$),
    mergeMap(([ { page }, state ]) => fetchApi(join('', [
      `/v2/${state.router.locale}/contents/search`,
      `?tags=${state.tag.current.name}`,
      `&page=${page}`,
      `&limit=${state.tag.limit}`,
      `&countable=1`,
    ]))),
    withLatestFrom(state$),
    map(([ response, state ]) => receivedArticlePage(
      state.pagination.page,
      calculateTotalPages(
        Number(response.headers.get('Total-Result') || 0),
        state.tag.limit,
      ),
      document.documentElement.scrollHeight,
      document.documentElement.scrollTop,
      fmap(article => formatArticle(state.router.locale, article))(response.body || []),
    )),
    logObservableError('tag :: fetchArticlesFromCurrentTagEpic', logger),
  )

// updatePaginationEpic :: Epic -> Action RECEIVED_PAGE
export const updatePaginationEpic = (action$, state$, { logger }) =>
  action$.pipe(
    ofType(RECEIVED_ARTICLE_PAGE),
    map(({ page, totalPages, scrollHeight, scrollTop }) => receivedPage(page, totalPages, scrollHeight, scrollTop)),
    logObservableError('tag :: updatePaginationEpic', logger),
  )

export default combineEpics(
  fetchCurrentTagEpic,
  fetchArticlesFromCurrentTagEpic,
  updatePaginationEpic,
)
